import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../lib/content";

export const FAQ = () => (
  <section id="faq" data-testid="faq" className="py-24 lg:py-32">
    <div className="max-w-4xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-5">
          Questions & answers
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1] tracking-tight mb-10">
          Everything you might be
          <span className="italic text-brand"> wondering</span>.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-border">
              <AccordionTrigger className="text-left font-serif text-xl text-brand-ink hover:no-underline hover:text-brand py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-brand-ink/70 text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
